import React from 'react';
import './PerfilIcons.css';

// Icono por defecto (icono de documentos)
const DefaultIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" viewBox="0 0 16 16">
    <path d="M5 0h8a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2 2 2 0 0 1-2 2H3a2 2 0 0 1-2-2h1a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1H1a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v9a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1H3a2 2 0 0 1 2-2"/>
    <path d="M1 6v-.5a.5.5 0 0 1 1 0V6h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm0 3v-.5a.5.5 0 0 1 1 0V9h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm0 2.5v.5H.5a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1H2v-.5a.5.5 0 0 0-1 0"/>
  </svg>
);

const PerfilIcons = ({ 
  text = "QUIENES SOMOS",
  icon: IconComponent = DefaultIcon,
  iconCopy: IconCopyComponent = DefaultIcon,
  className = "",
  colorPrimario = "#212121",
  colorSecundario = "#2aabee"
}) => {
  return (
    <button 
      className={`button perfil-icons-button ${className}`}
      style={{
        background: colorSecundario,  // Fondo del botón = colorSecundario
      }}
    >
      <p className="button__text">
        {text.split('').map((char, index) => (
          <span key={index} style={{ '--index': index }}>
            {char === ' ' ? '\u00A0' : char}
          </span>
        ))}
      </p>

      <div 
        className="button__circle"
        style={{
          background: colorPrimario,
        }}
      >
        <span className="button__icon">
          <IconComponent />
        </span>
        <span className="button__icon button__icon--copy">
          <IconCopyComponent />
        </span>
      </div>
    </button>
  );
};

export default PerfilIcons;